// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-000-exclude-from-analytics-js": function componentSrcPages000ExcludeFromAnalyticsJs() {
    return import("./../../src/pages/000_exclude_from_analytics.js"
    /* webpackChunkName: "component---src-pages-000-exclude-from-analytics-js" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-templates-about-js": function componentSrcTemplatesAboutJs() {
    return import("./../../src/templates/about.js"
    /* webpackChunkName: "component---src-templates-about-js" */
    );
  },
  "component---src-templates-blog-post-js": function componentSrcTemplatesBlogPostJs() {
    return import("./../../src/templates/blog-post.js"
    /* webpackChunkName: "component---src-templates-blog-post-js" */
    );
  },
  "component---src-templates-main-js": function componentSrcTemplatesMainJs() {
    return import("./../../src/templates/main.js"
    /* webpackChunkName: "component---src-templates-main-js" */
    );
  },
  "component---src-templates-recipes-js": function componentSrcTemplatesRecipesJs() {
    return import("./../../src/templates/recipes.js"
    /* webpackChunkName: "component---src-templates-recipes-js" */
    );
  }
};